<template>
    <div class="modal-step-container">
        <div class="quiz-question-cont">
            <formTxtInput
                :inputData="quizQuestion"
                @txtvalue="getTxtValue($event, quizQuestion)"
            />
        </div>
        <div class="quiz-answers-cont">
            <label for="" class="form-label" data-instructions="Up to 10 answers">Quiz Answers</label>
            <formTxtInput v-for="(txtInput, index) in quizAnswers"
                :key="txtInput.id"
                :inputData="txtInput"
                @removeInput="removeInputItem(index)"
                @txtvalue="getTxtValue($event, txtInput)"
            />
            <button v-if="quizAnswers.length < 10"
                class="btn btn-s btn-secondary btn-icon-16 btn-icon-plus add-answer-btn"
                @click="addInputItem">
                Add answer
            </button>
        </div>
    </div>
</template>

<script>
import formTxtInput from './formTxtInput'

export default {
    name: "gifCreationStep1",
    components: {
        formTxtInput,
    },
    data() {
        return {
            title: "Create Your Own Quiz",
            quizQuestion: {
                id: 1,
                inputValue: "",
                inputVisible: true,
                inputID: "quizQuestion",
                withLabel: true,
                labelTxt: "Quiz Question",
                placeHolderTxt: "i.e. Which Pokémon are you?",
                showCharCount: true,
                maxCharLength: 40,
                removeInputBtn: false,
                autoFocus: true,
                inputValidation: true,
            },
            inputIdCounter: 2,
            quizAnswers: [
                {
                    id: 1,
                    inputValue: "",
                    inputVisible: true,
                    inputID: "quizAnswer1",
                    withLabel: false,
                    placeHolderTxt: "Answer 1",
                    showCharCount: true,
                    maxCharLength: 24,
                    removeInputBtn: false,
                    inputValidation: true,
                },
                {
                    id: 2,
                    inputVisible: true,
                    inputValue: "",
                    inputID: "quizAnswer2",
                    withLabel: false,
                    placeHolderTxt: "Answer 2",
                    showCharCount: true,
                    maxCharLength: 24,
                    removeInputBtn: false,
                    inputValidation: true,
                },
            ],
            stepData: {
                title: "Hello!",
                quizQuestion: "",
                quizAnswers: [],
                inputErrors: [],
            }
        }
    },
    methods: {
        getTxtValue(val, item) {
            // get text data from $event and put it in inputValue
            item.inputValue = val;
            this.updateStepData();
        },
        addInputItem(){
            if (this.quizAnswers.length < 10) {
                let itemNum = this.quizAnswers.length;
                this.inputIdCounter += 1
                let inputItem = {
                    id: this.inputIdCounter,
                    inputValue: "",
                    inputVisible: true,
                    inputID: "quizAnswer" + (itemNum + 1),
                    withLabel: false,
                    placeHolderTxt: "Answer " + (itemNum + 1),
                    showCharCount: true,
                    maxCharLength: 24,
                    autoFocus: true,
                    inputValidation: true,
                }
                if (this.quizAnswers.length < 2) {
                    inputItem.removeInputBtn = false;
                } else {
                    inputItem.removeInputBtn = true;
                }
                this.quizAnswers.push(inputItem);
                this.resetInputPlaceholderTxt();
            }
            
        },
        removeInputItem(itemIndex) {
            this.quizAnswers.splice(itemIndex, 1);
            this.updateStepData();
            this.resetInputPlaceholderTxt();
        },
        resetInputPlaceholderTxt() {
            this.quizAnswers.forEach((input, index) => {
                input.inputID = "quizAnswer" + (index + 1);
                input.placeHolderTxt = "Answer " + (index + 1);
            });
        },
        getAnswers() {
            let answers = [];
            this.quizAnswers.forEach(answer => {
                answers.push(answer.inputValue);
            });
            return answers;
        },
        updateStepData() {
            this.stepData = {
                title: this.title,
                quizQuestion: this.quizQuestion.inputValue,
                quizAnswers: this.getAnswers()
            }
            this.emitData();
        },
        emitData() {
            this.$emit('stepData', this.stepData);
        },
         getInputIdCounter(array) {
            this.inputIdCounter = array.length;
        },
    },
    mounted() {
        this.updateStepData();
        this.getInputIdCounter(this.quizAnswers);
    },
}
</script>

<style>

</style>